import { isEmpty } from "lodash";
import React, { useState } from "react";
import { VariaveisAmbiente } from "../config";
import { EnumDeviceType } from "../model/enums/enum-device-type";

export const useDevice = () => {
  const [carregandoInterno, setCarregandoInternoState] = useState(false);

  const setCarregandoInterno = (valor: boolean) => {
    setCarregandoInternoState((prev) => {
      if (prev !== valor) return valor;
      return prev
    })
  }
  const carregando = carregandoInterno;

  const DeviceKit = React.useCallback((): any => {
    switch (VariaveisAmbiente.paymentDevice) {
      case EnumDeviceType.NAVIGATOR:
        return (window as any).NavigatorWebKit;
      case EnumDeviceType.CORDOVA:
        return (window as any).CordovaWebKit;
    }
  }, []);

  const PrintNativeKit = React.useCallback((): any => {
    switch (VariaveisAmbiente.paymentDevice) {
      case EnumDeviceType.NAVIGATOR:
        return (window as any).launchPrintNativeNavigator;
      case EnumDeviceType.CORDOVA:
      case EnumDeviceType.CORDOVA_POS:
        return (window as any).launchPrintNativeCordova;
    }
  }, []);

  const OpenExternalUrlKit = React.useCallback((): any => {
    if (VariaveisAmbiente.paymentDevice === EnumDeviceType.CORDOVA)
      return (window as any).openExternalUrl
  }, [])

  const VerificaSeAplicativoInstaladoKit = React.useCallback((): any => {
    switch (VariaveisAmbiente.paymentDevice) {
      case EnumDeviceType.CORDOVA:
      case EnumDeviceType.CORDOVA_POS:
        return (window as any).verificaSeAplicativoInstalado;
    }
  }, [])

  const AbrirAplicativoKit = React.useCallback((): any => {
    switch (VariaveisAmbiente.paymentDevice) {
      case EnumDeviceType.CORDOVA:
      case EnumDeviceType.CORDOVA_POS:
        return (window as any).abrirAplicativo;
    }
  }, [])

  const integrationStatus = React.useCallback(async (): Promise<boolean> => {
    return !isEmpty(DeviceKit());
  }, [DeviceKit]);

  const printNative = React.useCallback(
    async (
      textoImpressao: string,
      qtdeColunas: number,
      caminho: string,
      modelo: string,
      vias: number,
    ): Promise<void> => {
      setCarregandoInterno(true);
      return new Promise<void>(async (resolve, reject) => {
        const isIntegration = await integrationStatus();
        if (!isIntegration) {
          reject(new Error('SDK não Inicializado'));
        }
        const print = PrintNativeKit();
        try {
          await print(
            textoImpressao,
            qtdeColunas,
            caminho,
            modelo,
            vias,
            function (result: any, error: any) {
              setCarregandoInterno(false);
              if (error) {
                reject(error);
              }
              if (result !== 'success') {
                reject(
                  new Error('Erro ao realizar a Impressão. Detalhe: ' + result),
                );
              }
              resolve();
            },
          );
        } catch (e: any) {
          setCarregandoInterno(false);
          reject(e);
        }
      });
    },
    [PrintNativeKit, integrationStatus],
  );

  const openExternalUrl = React.useCallback(async (url: string): Promise<void> => {
    setCarregandoInterno(true);
    return new Promise<void>(async (resolve, reject) => {
      if (!(await integrationStatus()))
        reject(new Error('SDK não Inicializado'));
      const close = OpenExternalUrlKit()
      try {
        close(url, function (result: any, error: any) {
          setCarregandoInterno(false);
          if (error) {
            reject(error);
          }
          resolve();
        })
      } catch (e: any) {
        setCarregandoInterno(false);
        reject(e);
      } finally {
        setCarregandoInterno(false)
      }
    });
  }, [integrationStatus, OpenExternalUrlKit]);

  const verificaSeAplicativoInstalado = React.useCallback(async (packageName: string): Promise<boolean> => {
    setCarregandoInterno(true);
    return new Promise(async (resolve, reject) => {
      try {
        const callbackResult = (result: any, error: any) => {
          setCarregandoInterno(false);
          if (error) {
            reject(error)
          }
          resolve(result)
        };
        if (!(await integrationStatus()))
          reject(new Error('SDK não Inicializado'));

        const verificaSeAplicativoInstalado = VerificaSeAplicativoInstaladoKit()
        verificaSeAplicativoInstalado(packageName, callbackResult)
      } catch (e: any) {
        setCarregandoInterno(false);
        reject(e);
      } finally {
        setCarregandoInterno(false)
      }
    });
  }, [integrationStatus, VerificaSeAplicativoInstaladoKit]);

  const abrirAplicativo = React.useCallback(async (packageName: string, args: string): Promise<void> => {
    setCarregandoInterno(true);
    return new Promise<void>(async (resolve, reject) => {
      if (!(await integrationStatus()))
        reject(new Error('SDK não Inicializado'));

      const open = AbrirAplicativoKit()
      try {
        // Primeiro verifica se o app está instalado
        const getPackageName = await verificaSeAplicativoInstalado(packageName);
        if (!getPackageName) {
          throw new Error('Aplicativo não está instalado');
        }

        open(getPackageName, args, function (result: any, error: any) {
          setCarregandoInterno(false);
          if (error) {
            reject(error);
          }
          resolve(result);
        })
      } catch (e: any) {
        setCarregandoInterno(false);
        reject(e);
      } finally {
        setCarregandoInterno(false)
      }
    });
  }, [integrationStatus, AbrirAplicativoKit, verificaSeAplicativoInstalado]);

  return {
    printNative,
    openExternalUrl,
    abrirAplicativo,
    carregando
  }

}